import styled from 'styled-components'
import { colors } from '../../theme'

export const Button = styled.button`
  border: none;
  background-color: ${colors.surface};
  cursor: pointer;
`
export const DivPag = styled.div<{ marginBottom?: string }>`
  margin: 10px 0px 50px 0px;
  margin-bottom: ${({ marginBottom }) => marginBottom};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 050px;
`
export const SpanNumQtd = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${colors.grey500};
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin: 20px 0;
  margin-left: 15px;
`

export const SpanNum = styled.div<{ checkNum: boolean }>`
  background-color: ${({ checkNum }) =>
    checkNum ? `${colors.accentBg}` : `${colors.surface}`};
  color: ${({ checkNum }) =>
    checkNum ? `${colors.white}` : `${colors.grey500}`};
  cursor: pointer;
  margin: 20px 10px;
  width: 20px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  border-radius: 4px;
`
export const DivLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
